import { useEffect } from 'react';
import { navigate } from '@reach/router';
import { apiHolder, apis, api, getIn18Text, environment } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { guardString } from '../../../../../../../web-edm/src/utils';
export const env = typeof environment === 'string' ? environment : 'local';
export const isDev = !['prod', 'prev'].includes(env);
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const routerWord = systemApi.isWebWmEntry() ? '#intelliMarketing' : '#edm';
const dataStoreApi = api.getDataStoreApi();
export const getSendCount = async (params) => {
    const { emailList, sendType, businessType, draftId, sourcePage, from, back, channel, independentWindow } = params;
    edmApi.getSendCount().then(async (data) => {
        if (isDev && (!from || from === 'default')) {
            throw new Error('请明确业务来源(from)字段, 不接受 default 来源');
        }
        const keyValue = 'customerMarketingEmails';
        try {
            await dataStoreApi.delFromDB(keyValue);
            await dataStoreApi.putToDB(keyValue, JSON.stringify(emailList));
            let path = `${routerWord}?page=write`;
            path += `&key=${keyValue}`;
            const fromPage = from || 'customer';
            if (guardString(fromPage)) {
                path += `&from=${fromPage}`;
            }
            if (guardString(businessType)) {
                path += `&businessType=${businessType}`;
            }
            if (guardString(sendType)) {
                path += `&sendType=${sendType}`;
            }
            if (guardString(draftId)) {
                path += `&draftId=${draftId}`;
            }
            if (guardString(back)) {
                path += `&back=${back}`;
            }
            if (guardString(sourcePage)) {
                path += `&sourcePage=${sourcePage}`;
            }
            if (channel) {
                path += `&channel=${channel}`;
            }
            path += `&_t=${new Date().getTime()}`;
            if (independentWindow) {
                systemApi.openMarketingTaskPage(path);
            }
            else {
                navigate(path);
            }
        }
        catch (error) {
            console.error('customerMarketingEmails-error', error);
        }
    });
};
export const useEdmSendCountV2 = (params) => {
    const { emailList, sendType, businessType, draftId, sourcePage, from, back, channel, tableId, independentWindow } = params;
    useEffect(() => {
        console.log('一键营销-hooks', emailList);
        if (emailList.length) {
            if (emailList.length === 1 && emailList[0].contactEmail === 'noEmials') {
                const content = tableId === 'leads' ? getIn18Text('SUOXUANXIANSZWYX') : getIn18Text('SUOXUANKEHUZANWUYOUXIANG');
                SiriusMessage.warning({
                    content,
                });
            }
            else {
                getSendCount({ emailList, sendType, businessType, draftId, sourcePage, from, back, channel, independentWindow });
            }
        }
    }, [emailList]);
};
export default (emailList, sendType, businessType, draftId, sourcePage, from, back, channel, independentWindow) => {
    useEdmSendCountV2({
        emailList,
        sendType,
        businessType,
        draftId,
        sourcePage,
        from,
        back,
        channel,
        independentWindow,
    });
};
